module.exports = __webpack_public_path__ + "static/logo-color-87bce08f23cc5286e9281b79cd89b935.svg";